import { create } from 'zustand'

interface SharedProductState {
    /** URL shared from external app via share extension */
    sharedUrl: string | null
    /** Set the shared URL */
    setSharedUrl: (url: string | null) => void
    /** Clear the shared URL (after it's been processed) */
    clearSharedUrl: () => void
}

/**
 * Store for managing product URLs shared from external apps
 * via the iOS Share Extension
 */
export const useSharedProductStore = create<SharedProductState>((set) => ({
    sharedUrl: null,
    setSharedUrl: (url) => set({ sharedUrl: url }),
    clearSharedUrl: () => set({ sharedUrl: null }),
}))

